import sortBy from 'lodash/sortBy';

import { SelectOption, UserLocale } from '@/shared/config';

import { Countries } from '../config';

import { getCountryName } from './getCountryName';

export const makeCountryOptions = (
  countries: Countries,
  locale: UserLocale,
): SelectOption[] =>
  sortBy(
    Object.keys(countries).map((countryCode) => ({
      value: countryCode,
      label: getCountryName(countryCode, countries[countryCode].names, locale),
    })),
    'label',
  );
